import * as actionTypes from '../actionTypes';

export function getIndividualStaffData(data) {
	return {
		type: actionTypes.GET_INDIVIDUAL_STAFF_DATA,
		payload: data
	};
}
